import { render } from "./SavedTablesListActionsColumn.vue?vue&type=template&id=85201f9a"
import script from "./SavedTablesListActionsColumn.vue?vue&type=script&lang=js"
export * from "./SavedTablesListActionsColumn.vue?vue&type=script&lang=js"

import "./SavedTablesListActionsColumn.vue?vue&type=style&index=0&id=85201f9a&lang=scss"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QList,QItem,QItemSection,QItemLabel});qInstall(script, 'directives', {ClosePopup});
